import env from 'env';
import Cookies from 'js-cookie';
import { safeParse, safeStringify } from 'utils';

export const KEYS = {
  // auth
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh-token',
  CURRENT_USER_ID: 'current-user-id',
  HAS_JUST_REGISTERED: 'has-just-registered',
  // 2fa
  TWO_FA: '2fa',
  IS_CONF_TFA: 'is-tfa-conf',
  OT_PATH: 'ot-tfa-path',
  UID: 'u-id',
  // rest
  DR_TOKEN: 'dr-token',
  SHAREABLE_LINK_TOKEN: 'shareable-link-token',
  RFI_TOKEN: 'rfi-token',
};

export const getDemoKeys = () =>
  Object.fromEntries(
    Object.entries(KEYS).map(([key, value]) => [key, `demo-${value}`]),
  );

export const COOKIE_KEYS = env.IS_DEMO ? getDemoKeys() : KEYS;

const domain = env.DOMAIN;

export default {
  ram: {} as Record<string, string>,
  setItem(key: string, value: Record<string, any> | string | boolean | number) {
    try {
      Cookies.set(key, safeStringify(value), { domain });
    } catch (e) {
      this.ram[key] = safeStringify(value);
    }
  },
  removeItem(key: string): void {
    try {
      Cookies.remove(key, { domain });
    } catch (e) {
      this.ram[key] = undefined;
    }
  },
  getItem<T>(key: string): T {
    const cookieItem = safeParse(Cookies.get(key));

    if (cookieItem !== undefined) return cookieItem;

    return safeParse(this.ram[key]);
  },
};
